export const META_PIXEL_ID = '1070366125738584'

type FbqFn = (...args: unknown[]) => void

declare global {
  interface Window {
    fbq?: FbqFn & { callMethod?: FbqFn; queue?: unknown[] }
    _fbq?: unknown
  }
}

let initialized = false

/**
 * Injects the official Meta Pixel base code and initializes the pixel.
 * Safe to call multiple times — it only runs once.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  const w = window as any

  if (!w.fbq) {
    const n: any = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    w.fbq = n
    w._fbq = n
  }

  const existing = document.querySelector<HTMLScriptElement>(
    'script[data-meta-pixel="true"]',
  )

  if (!existing) {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    script.setAttribute('data-meta-pixel', 'true')
    // Append to head (or body/documentElement as fallbacks) instead of
    // relying on an existing <script> tag being present in the document.
    const host = document.head || document.body || document.documentElement
    host.appendChild(script)
  }

  window.fbq?.('init', META_PIXEL_ID)
}

/** Fires a standard Meta Pixel event. */
export function trackEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, params)
}

/** Fires a custom (non-standard) Meta Pixel event. */
export function trackCustomEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  window.fbq?.('trackCustom', event, params)
}

export const PRODUCT = {
  content_name: 'Enciclopedia del Reinicio Metabólico',
  content_ids: ['metabolismo-restart-pro'],
  content_type: 'product',
  value: 17.0,
  currency: 'USD',
}
